<div class="criterion-row-container" cdkDrag cdkDragBoundary=".rules-list" cdkDragLockAxis="y">
    <div [class]="tabClass()">
        @if (displayIndex()) {
            {{ index() + 1 }}
        }
    </div>
    <div class="criterion-container">
        <div class="criterion-content">
            <div class="criterion-type-badge">
                <fa-icon [icon]="faCalendar" />
                {{ type }}
            </div>
            <div class="cmt-level-row">
                <mat-form-field class="cmt-level-dropdown">
                    <mat-label>Hierarchy Level</mat-label>
                    <mat-select [formControl]="criterionForm.controls.cmtLevel">
                        @for (level of cmtLevels(); track $index) {
                            <mat-option [value]="level.value" (click)="onCmtLevelSelect()"
                                >{{ level.displayName }}
                            </mat-option>
                        }
                    </mat-select>
                    @if (criterionForm.controls.cmtLevel.errors?.['required']) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
                <div class="category-typeahead">
                    <r1-compass-lib-typeahead-search
                        [valueFormControl]="criterionForm.controls.cmtCategory"
                        [displayFormControl]="criterionForm.controls.cmtCategory"
                        [resultDisplayPropertyPath]="'name'"
                        [resultValuePropertyPath]="'code'"
                        [disabled]="displayOnly()"
                        [searchResults]="categoryTypeaheadResults"
                        (search)="onCategoryTypeaheadSearch($event)" />
                </div>
            </div>

            <div class="metric-row">
                <mat-form-field class="metric-dropdown">
                    <mat-label>Metric</mat-label>
                    <mat-select [formControl]="criterionForm.controls.metric">
                        @for (metric of metrics(); track $index) {
                            <mat-option [value]="metric.name">{{ metric.displayName }}</mat-option>
                        }
                    </mat-select>
                    @if (criterionForm.controls.metric.errors?.['required']) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="channel-dropdown">
                    <mat-label>Channel</mat-label>
                    <mat-select [formControl]="criterionForm.controls.channel" multiple>
                        @for (channel of channels(); track $index) {
                            <mat-option [value]="channel.value">{{ channel.displayName }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <div class="checkbox-container">
                    <mat-checkbox [formControl]="criterionForm.controls.not">Not</mat-checkbox>
                </div>
                <mat-form-field class="comparator-dropdown">
                    <mat-label>Comparator</mat-label>
                    <mat-select [formControl]="criterionForm.controls.comparator">
                        @for (comparator of comparators; track $index) {
                            <mat-option [value]="comparator.value">{{ comparator.label }}</mat-option>
                        }
                    </mat-select>
                    @if (criterionForm.controls.comparator.errors?.['required']) {
                        <mat-error>Value required</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="value-input">
                    <mat-label>Value</mat-label>
                    <input matInput [formControl]="criterionForm.controls.value1.controls.value" />
                </mat-form-field>
                <mat-form-field class="hand-priced-dropdown">
                    <mat-label>Hand Priced?</mat-label>
                    <mat-select [formControl]="criterionForm.controls.isHandPriced">
                        @for (option of handpriceOptions; track $index) {
                            <mat-option [value]="option.value">{{ option.displayValue }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="vendor-accordion-container">
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>Vendor Options</mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="vendor-options-typeahead-container">
                            <div class="vendor-typeahead">
                                <r1-compass-lib-typeahead-search
                                    [valueFormControl]="vendorTypeaheadValueControl"
                                    [displayFormControl]="vendorTypeaheadDisplayControl"
                                    [resultDisplayPropertyPath]="'displayValue'"
                                    [resultValuePropertyPath]="'value'"
                                    [disabled]="displayOnly()"
                                    [searchResults]="vendorTypeaheadResults"
                                    (search)="onVendorTypeaheadSearch($event)"
                                    (resultSelection)="onVendorSelection($event)" />
                            </div>
                            <div class="chip-list-container">
                                @for (vendor of criterionForm.controls.vendors.value; track $index) {
                                    <mat-chip-row removeable (removed)="onRemoveSelectedVendor($index)"
                                        >{{ vendor }}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip-row>
                                }
                            </div>
                        </div>
                        <div class="self-manufactured-options-container">
                            <mat-form-field class="self-manufactured-dropdown">
                                <mat-label>Self Manufactured Options</mat-label>
                                <mat-select [formControl]="criterionForm.controls.selfManufactured" multiple>
                                    @for (option of selfManufacturedOptions(); track $index) {
                                        <mat-option [value]="option.value">{{ option.displayName }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field class="ssp-dropdown">
                                <mat-label>SSP Options</mat-label>
                                <mat-select [formControl]="criterionForm.controls.ssp" multiple>
                                    @for (option of sspOptions(); track $index) {
                                        <mat-option [value]="option.value">{{ option.displayName }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
            <mat-accordion>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Additional Options</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="additional-options-container">
                        <mat-form-field class="private-label-dropdown">
                            <mat-label>Private Label Options</mat-label>
                            <mat-select [formControl]="criterionForm.controls.privateLabel" multiple>
                                @for (option of privateLabelOptions(); track $index) {
                                    <mat-option [value]="option.value">{{ option.displayName }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div class="criterion-options-container">
            @if (deletable()) {
                <div
                    class="trash-icon-container"
                    role="button"
                    aria-disabled="true"
                    (click)="onDelete()"
                    (keydown)="onDelete()">
                    <fa-icon [icon]="faTrash" />
                </div>
            } @else {
                <div class="empty-icon-container"></div>
            }
        </div>
    </div>
</div>
